// extracted by mini-css-extract-plugin
export default {"currencyInputWrapper":"FieldCurrencyInput_currencyInputWrapper__r0Ski","input":"FieldCurrencyInput_input__ivvM6","currencySymbol":"FieldCurrencyInput_currencySymbol__TVIX5"};